var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { last } from '../../../utils/helper/lodash_replacements';
import { QuestionTypeName } from '../../learnware/LearnwareEnums';
export class TrayAnswers {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get tray() {
        return this.parent;
    }
    get app() {
        return this.tray.app;
    }
    get frontalAnswer() {
        return this.allAnswersInLine[this.tray.trayLine.indexOfFrontalAnswer];
    }
    get answersFromDatabase() {
        return this.app.history.historyAnswers.answersFromDatabase;
    }
    get answersSincePageLoad() {
        return [
            ...this.app.history.historyRecentAnswers.answersFinishedSincePageLoad,
            ...this.app.pose.poseAnswer.currentlyPosedAsArray.filter(a => a.miniQuestion && a.miniQuestion.questionType !== QuestionTypeName.CycleEnd),
        ];
    }
    get answersPosedSincePageLoad() {
        return this.answersSincePageLoad.filter(answer => !!answer.poseDate);
    }
    get answersCompletedSincePageLoad() {
        return this.answersSincePageLoad.filter(answer => !!answer.completeDate);
    }
    get answersFinishedSincePageLoad() {
        return this.app.history.historyAnswers.answersFinishedSincePageLoad;
    }
    get answersPosed() {
        return [...this.answersFromDatabase, ...this.answersPosedSincePageLoad];
    }
    get answersCompleted() {
        return [...this.answersFromDatabase, ...this.answersCompletedSincePageLoad];
    }
    get allAnswersInLine() {
        return [...this.answersPosed, ...this.tray.funnel.funnelLine.funnelAnswers];
    }
    get numberOfAnswersInTray() {
        return this.allAnswersInLine.length;
    }
    get lastCompletedAnswer() {
        return last(this.answersCompleted);
    }
    get lastPosedAnswer() {
        return last(this.answersPosed);
    }
}
__decorate([
    computed
], TrayAnswers.prototype, "answersSincePageLoad", null);
__decorate([
    computed
], TrayAnswers.prototype, "answersPosedSincePageLoad", null);
__decorate([
    computed
], TrayAnswers.prototype, "answersCompletedSincePageLoad", null);
__decorate([
    computed
], TrayAnswers.prototype, "answersPosed", null);
__decorate([
    computed
], TrayAnswers.prototype, "numberOfAnswersInTray", null);
